import {ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection} from "@angular/core";
import {DatePipe} from "@angular/common";
import {provideHttpClient} from "@angular/common/http";
import {provideRouter, withComponentInputBinding, withRouterConfig} from "@angular/router";
import {routes} from "./app.routes";
import {MAT_NATIVE_DATE_FORMATS, provideNativeDateAdapter} from "@angular/material/core";
import {OVERLAY_DEFAULT_CONFIG} from "@angular/cdk/overlay";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(),
    provideRouter(routes, withComponentInputBinding(), withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    provideNativeDateAdapter(MAT_NATIVE_DATE_FORMATS),
    DatePipe,
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
  ]
};
